import React from 'react';
import New from './New';
import { useTitle } from '../../hooks/useTitle';

const MypageRecordNew = () => {
  useTitle('Ton Bébé | 提供実績 新規登録');

  return (
    <main className="sub">
      <New />
    </main>
  );
}

export default MypageRecordNew;
